import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { NextButton, SharedStyledComponents } from '../OnboardingPage';
import { getErrMsgFromResp } from '../../../utils/errorHandler';
import pencilIcon from '../../../images/pencil-icon.svg';
import closeIcon from '../../../images/close.png';
import linkIcon from '../../../images/link-icon.png';
import instaIcon from '../../../images/insta-icon.png';
import {
  GET_KYC_REVIEW_DETAILS,
  GET_REVIEW_DETAILS,
} from '../../../graphql/queries/onboardingQueries';
import { COMPLETE_REVIEW_KYC_DETAILS } from '../../../graphql/mutations/onboardingmutations';
import KYCSuccess from './KYCSuccess';
import { useOnboarding } from '../../../contexts/OnboardingContext';
import { logger } from '../../../utils/logger';
import SkeletonLoader from '../../../components/Common/SkeletonLoader';
const toFormattedName = (str) => {
  // Capitalize the first letter of each word and replace underscores with spaces
  return (
    str &&
    str
      .replace('_', ' ') // Replace underscores with spaces
      .split(' ') // Split the string into an array of words
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
      .join(' ')
  ); // Join back the words with spaces
};

const ReviewKYCDetails = () => {
  // const urlParams = new URLSearchParams(window.location.search);
  // const eaadhaar = urlParams.get('eaadhaar');

  const [isAadhaarVerified, setIsAadhaarVerified] = useState(false);
  const [aadhaarVerificationSource, setAadhaarVerificationSource] =
    useState('');
  const [respLoading, setRespLoading] = useState(true);
  const {
    handleNextButton,
    handleSteps,
    client,
    editingMode,
    setStepsInfo,
    setEditingMode,
    detailsFlow,
    isOnboardingDone,
    setIsOnboardingDone,
  } = useOnboarding();
  const { ReviewWrapper } = SharedStyledComponents;
  const [brandName, setBrandName] = useState('');
  const [loading, setLoading] = useState(false);

  const [error, setError] = useState(null);
  const [formattedProof, setFormattedProof] = useState({
    front: {
      name: 0,
      path: '',
      originalFileName: '',
    },
    back: {
      name: 0,
      path: '',
      originalFileName: '',
    },
    pan: {
      name: 0,
      path: '',
      originalFileName: '',
    },
    coi: {
      name: 0,
      path: '',
      originalFileName: '',
    },
  });
  const [resp, setResp] = useState({
    accountDetails: {
      id: '',
      accountNo: '',
      ifscCode: '',
    },
    gstDetails: {
      id: '',
      gstNo: '',
      cin: '',
      donotHaveGstDetails: false,
    },
    businessCategory: {
      id: '',
      category: {
        id: 0,
        name: '',
        parentCategory: '',
      },
    },
    idProof: {},
    verifyPAN: {
      PAN: '',
      PANFor: '',
      nameOnPAN: '',
    },
  });

  // Helper: extract parsed data from a dedicated detail container { details: [{ data }] }
  const parseDetail = (container) => {
    const data = container?.details?.[0]?.data;
    if (data == null) return {};
    try {
      return typeof data === 'string' ? JSON.parse(data) : data;
    } catch {
      return {};
    }
  };

  useEffect(() => {
    // Skip the review fetch once onboarding is already complete - this
    // component continues to render KYCSuccess inline, so without this guard
    // a refresh on the success screen would re-hit GET_KYC_REVIEW_DETAILS.
    if (isOnboardingDone) {
      setRespLoading(false);
      return;
    }
    const fetchDbResp = async () => {
      setLoading(true);
      logger.log('fetching data');
      setError(null);
      try {
        const response = await client.request(GET_KYC_REVIEW_DETAILS, {
          panType: 'AUTHORISED_SIGNATORY',
        });
        logger.log('review resp', response);

        const categoryData = parseDetail(response.businessCategory);

        setResp({
          accountDetails: response.accountDetails ?? resp.accountDetails,
          gstDetails: response.gstDetails ?? resp.gstDetails,
          idProof: response.idProof ?? resp.idProof,
          verifyPAN: response.verifyPAN ?? resp.verifyPAN,
          businessCategory: {
            id: '',
            category: {
              id: categoryData?.categoryId ?? categoryData?.category?.id ?? 0,
              name: categoryData?.category?.name ?? '',
              parentCategory: categoryData?.category?.parentCategory ?? '',
            },
          },
        });
        setRespLoading(false);
      } catch (err) {
        logger.log(err);
        // setError(getErrMsgFromResp(err));
      } finally {
        setLoading(false);
      }
    };

    fetchDbResp();
    logger.log('here');
  }, []);

  useEffect(() => {
    if (resp.idProof && resp.idProof.length > 0) {
      const formattedData = {};
      logger.log(' resp.idProof', resp.idProof);
      const aadhaarDocs = resp.idProof.filter((item) => item?.docType === 'aadhaar');
      const aadhaarSources = aadhaarDocs
        .map((item) => String(item?.source || '').toUpperCase())
        .filter(Boolean);

      const hasCkyc = aadhaarSources.includes('CKYC');
      const hasDigilocker = aadhaarSources.includes('DIGILOCKER');
      const hasAadhaarDoc = aadhaarDocs.length > 0;

      setIsAadhaarVerified(hasAadhaarDoc);

      if (hasCkyc) {
        setAadhaarVerificationSource('CKYC');
      } else if (hasDigilocker) {
        setAadhaarVerificationSource('DIGILOCKER');
      } else {
        setAadhaarVerificationSource('');
      }

      // Iterate over the array
      resp.idProof.forEach(({ docType, filePath, data }) => {
        if (docType.includes('_front')) {
          formattedData.front = {
            name: docType,
            path: filePath?.match(/[^\\/]+$/)?.[0] || filePath,
            originalFileName: data?.originalFileName,
          };
        } else if (docType.includes('_back')) {
          formattedData.back = {
            name: docType,
            path: filePath?.match(/[^\\/]+$/)?.[0] || filePath,
            originalFileName: data?.originalFileName,
          };
        } else if (docType === 'aadhaar') {
          setIsAadhaarVerified(true);
        } else {
          formattedData[docType] = {
            name: docType,
            path: filePath?.match(/[^\\/]+$/)?.[0] || filePath,
            originalFileName: data?.originalFileName,
          };
        }
      });
      logger.log(formattedData);
      setFormattedProof(formattedData);
    }
  }, [resp]);
  logger.log('formattedProof', formattedProof);
  logger.log('isaadharverified', isAadhaarVerified);

  const handleSubmit = async () => {
    setLoading(true);
    setError(null);
    if (isOnboardingDone) {
      setStepsInfo((prev) => ({
        ...prev,
        finished: true,
      }));
      return;
    }

    try {
      const response = await client.request(COMPLETE_REVIEW_KYC_DETAILS, {});
      logger.log('response REVIEW', response);
      if (response?.completeReviewKycDetails) {
        // setStepsInfo((prev) => ({
        //   ...prev,
        //   finished: true,
        // }));
        // await new Promise((resolve) => setTimeout(resolve, 1000));
        setIsOnboardingDone(true);
      } else {
        setError('Failed to update User Step.');
        throw response;
      }
    } catch (err) {
      logger.log('err', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setEditingMode(true);
  }, []);

  const isComponentPresent = (type) => {
    return detailsFlow.some((item) => item.component === type);
  };

  const getDynamicItemsCount = () => {
    return Object.keys(resp).length;
  };

  return (
    <Wrapper className="flex-wrapper">
      {isOnboardingDone ? (
        <KYCSuccess />
      ) : respLoading ? (
        <SkeletonLoader itemsCount={getDynamicItemsCount()} />
      ) : (
        <>
          <ReviewWrapper>
            <div className="form-steps">
              <div className="steps-header">
                <h3>Review Your Details</h3>
                <p className="title">
                  Please confirm your details before submitting
                </p>
              </div>

              <div className="review-details">
                {/* Name Section */}
                {isComponentPresent('AccountDetails') && (
                  <ul className="detail-list">
                    <p className="title-heading">Add Bank Details</p>
                    <div className="list">
                      <button
                        className="edit-btn"
                        onClick={() => handleSteps('AccountDetails')}
                      >
                        <img src={pencilIcon} alt="edit" />
                      </button>
                      <li>
                        <span>Account number</span>
                        <strong>{resp.accountDetails.accountNo}</strong>
                      </li>
                      <li>
                        <span>IFSC code</span>
                        <strong>{resp.accountDetails.ifscCode}</strong>
                      </li>
                    </div>
                  </ul>
                )}
                {/* Business Pan Section Section */}
                {isComponentPresent('GstDetails') && (
                  <ul className="detail-list">
                    <p className="title-heading">GST Details</p>

                    <div className="list">
                      <button
                        className="edit-btn"
                        onClick={() => handleSteps('GstDetails')}
                      >
                        <img src={pencilIcon} alt="edit" />
                      </button>
                      {resp.gstDetails.donotHaveGstDetails ? (
                        <li>
                          <span>GST details not available</span>
                        </li>
                      ) : (
                        <>
                          <li>
                            <span>CIN number</span>
                            <strong>{resp.gstDetails.cin}</strong>
                          </li>
                          <li>
                            <span>GST number</span>
                            <strong>{resp.gstDetails.gstNo}</strong>
                          </li>
                        </>
                      )}
                    </div>
                  </ul>
                )}
                {isComponentPresent('EnterPAN') && (
                  <ul className="detail-list">
                    <p className="title-heading">
                      Your Authorised Signatory’s PAN Number
                    </p>
                    <div className="list">
                      <button
                        className="edit-btn"
                        onClick={() => handleSteps('EnterPAN')}
                      >
                        <img src={pencilIcon} alt="edit" />
                      </button>
                      <li>
                        <span>PAN Number</span>
                        <strong>{resp.verifyPAN.PAN}</strong>
                      </li>
                      <li>
                        <span>Authorised Signatory Name</span>
                        <strong>{resp.verifyPAN.nameOnPAN}</strong>
                      </li>
                    </div>
                  </ul>
                )}
                {isComponentPresent('IdProof') && (
                  <ul className="detail-list">
                    <p className="title-heading">Identity Proof</p>
                    <div className="list">
                      {aadhaarVerificationSource === 'CKYC' ? (
                        <li>
                          <span>Aadhaar</span>
                          <strong className="verified">✓ CKYC Verified</strong>
                        </li>
                      ) : aadhaarVerificationSource === 'DIGILOCKER' ? (
                        <li>
                          <span>Aadhaar</span>
                          <strong className="verified">
                            ✓ DigiLocker Verified
                          </strong>
                        </li>
                      ) : isAadhaarVerified ? (
                        <li>
                          <span>Aadhaar</span>
                          <strong className="verified">✓ Verified</strong>
                        </li>
                      ) : (
                        <>
                          <button
                            className="edit-btn"
                            onClick={() => handleSteps('IdProof')}
                          >
                            <img src={pencilIcon} alt="edit" />
                          </button>
                          {(Array.isArray(resp.idProof) ? resp.idProof : [])
                            .filter(
                              ({ docType }) =>
                                typeof docType === 'string' &&
                                (docType.endsWith('_front') ||
                                  docType.endsWith('_back'))
                            )
                            .map(({ docType, filePath }) => {
                              const fileName =
                                filePath?.match(/[^\\/]+$/)?.[0] || filePath;
                              return (
                                <li key={docType}>
                                  <span>{toFormattedName(docType)}</span>
                                  <strong>{fileName || '-'}</strong>
                                </li>
                              );
                            })}
                        </>
                      )}
                    </div>
                  </ul>
                )}
                {isComponentPresent('BusinessIdProof') && (
                  <ul className="detail-list">
                    <p className="title-heading">Business Document</p>
                    <div className="list">
                      <button
                        className="edit-btn"
                        onClick={() => handleSteps('BusinessIdProof')}
                      >
                        <img src={pencilIcon} alt="edit" />
                      </button>
                      <li>
                        <span>Company PAN</span>
                        <strong>
                          {formattedProof?.pan?.originalFileName ||
                            formattedProof?.pan?.path}
                        </strong>
                      </li>
                      <li>
                        <span>Certificate Of Incorporation</span>
                        <strong>
                          {formattedProof?.coi?.originalFileName ||
                            formattedProof?.coi?.path}
                        </strong>
                      </li>
                    </div>
                  </ul>
                )}

                {/* Business Pan Section Section */}
                {isComponentPresent('BusinessCategory') && (
                  <ul className="detail-list">
                    <p className="title-heading">Business Category</p>
                    <div className="list">
                      <button
                        className="edit-btn"
                        onClick={() => handleSteps('BusinessCategory')}
                      >
                        <img src={pencilIcon} alt="edit" />
                      </button>
                      <li>
                        <span>Category</span>
                        <strong>
                          {resp.businessCategory.category?.parentCategory}
                        </strong>
                      </li>
                      <li>
                        <span>Sub-Category</span>
                        <strong>{resp.businessCategory.category?.name}</strong>
                      </li>
                    </div>
                  </ul>
                )}
              </div>
            </div>
          </ReviewWrapper>
          <NextButton
            onClick={handleSubmit}
            loading={loading}
            disabled={loading}
            error={error}
          >
            Submit
          </NextButton>
        </>
      )}
    </Wrapper>
  );
};
const Wrapper = styled.div`
  // margin-top: -60px;
`;

export default ReviewKYCDetails;
